'use client'

import {
   Badge,
   Box,
   Card,
   Container,
   Group,
   Stack,
   Text,
   ThemeIcon
} from '@blocks'
import {
   siteFeatureCardBackgroundHex,
   siteFeatureCardShadow,
   siteSectionBodyHex,
   siteSectionCardRadiusPx,
   siteSectionHeadingHex,
   siteTypographySectionLeadFontSizeDesktop,
   siteTypographySectionLeadFontSizeMobile,
   siteTypographySectionTitlePrimaryFontSizeDesktop,
   siteTypographySectionTitlePrimaryFontSizeMobile,
   siteTypographySectionTitleSecondaryFontSizeDesktop,
   siteTypographySectionTitleSecondaryFontSizeMobile
} from '@constants'
import {useMediaQuery} from '@hooks'
import {IconCheck, IconDroplets} from '@icons'
import {FaqInSection} from '@/blocks/site/FaqAccordion'

const washOptions = [
   'Degreaser / tyre cleaner',
   'Pre-soak',
   'High-pressure soap',
   'Foam brush',
   'High-pressure rinse',
   'Triple foam conditioner',
   'High-pressure wax'
]

export const SelfServe = () => {
   const isMobile = useMediaQuery('(max-width: 768px)')

   return (
      <Box
         id={'self-serve'}
         bg={'#f4f7ff'}
         style={{scrollMarginTop: 120}}
      >
         <Container
            py={isMobile ? 80 : 120}
            size={'xl'}
         >
            <Stack gap={isMobile ? 50 : 70}>
               <Group
                  align={'stretch'}
                  gap={60}
                  wrap={'wrap'}
               >
                  <Stack
                     gap={30}
                     style={{flex: '1 1 340px'}}
                  >
                     <Stack gap={12}>
                        <Badge
                           variant={'light'}
                           color={'blue'}
                           size={'lg'}
                           fw={700}
                           tt={'uppercase'}
                        >
                           Self-Serve Wash Bays
                        </Badge>
                        <Text
                           c={siteSectionHeadingHex}
                           fz={
                              isMobile
                                 ? siteTypographySectionTitlePrimaryFontSizeMobile
                                 : siteTypographySectionTitlePrimaryFontSizeDesktop
                           }
                           fw={800}
                           lh={1.05}
                        >
                           Your Way. Your Pace.
                        </Text>
                     </Stack>
                     <Stack gap={18}>
                        <Text
                           c={siteSectionBodyHex}
                           fz={
                              isMobile
                                 ? siteTypographySectionLeadFontSizeMobile
                                 : siteTypographySectionLeadFontSizeDesktop
                           }
                           fw={500}
                           lh={1.7}
                        >
                           Prefer to wash your vehicle your own way?
                           Our self-serve bays give you the tools to
                           do a detailed clean at your own pace.
                        </Text>
                        <Text
                           c={siteSectionBodyHex}
                           fz={
                              isMobile
                                 ? siteTypographySectionLeadFontSizeMobile
                                 : siteTypographySectionLeadFontSizeDesktop
                           }
                           fw={500}
                           lh={1.7}
                        >
                           From wheels and tyres through to the final
                           rinse, our self-serve bays are set up to
                           help you get a proper clean from top to
                           bottom.
                        </Text>
                     </Stack>
                  </Stack>
                  <Card
                     p={isMobile ? 36 : 44}
                     radius={siteSectionCardRadiusPx}
                     style={{
                        flex: '1 1 340px',
                        background: siteFeatureCardBackgroundHex,
                        boxShadow: siteFeatureCardShadow
                     }}
                  >
                     <Stack gap={25}>
                        <Group
                           gap={15}
                           align={'center'}
                        >
                           <ThemeIcon
                              p={12}
                              size={60}
                              color={'white'}
                              variant={'light'}
                              radius={'lg'}
                           >
                              <IconDroplets
                                 stroke={1.6}
                                 size={34}
                              />
                           </ThemeIcon>
                           <Text
                              c={'white'}
                              fz={
                                 isMobile
                                    ? siteTypographySectionTitleSecondaryFontSizeMobile
                                    : siteTypographySectionTitleSecondaryFontSizeDesktop
                              }
                              fw={700}
                           >
                              Available Wash Options
                           </Text>
                        </Group>
                        <Stack gap={14}>
                           {washOptions.map((option) => (
                              <Group
                                 key={option}
                                 align={'center'}
                                 gap={14}
                                 wrap={'nowrap'}
                              >
                                 <IconCheck
                                    size={18}
                                    color={'rgba(255,255,255,0.7)'}
                                 />
                                 <Text
                                    c={'white'}
                                    fz={
                                       isMobile
                                          ? siteTypographySectionLeadFontSizeMobile
                                          : siteTypographySectionLeadFontSizeDesktop
                                    }
                                    fw={500}
                                 >
                                    {option}
                                 </Text>
                              </Group>
                           ))}
                        </Stack>
                     </Stack>
                  </Card>
               </Group>
               <FaqInSection
                  categoryPriority={'self-serve-car-wash'}
                  sectionTone={'light'}
               />
            </Stack>
         </Container>
      </Box>
   )
}
